import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { Offcanvas, Popover, Tooltip, ScrollSpy } from 'bootstrap';
import { Swiper, SwiperSlide } from 'swiper/vue';
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue3-apexcharts';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/app.scss';
import 'vue3-toastify/dist/index.css';

import App from './App.vue';
import router from './router';
// Re-exported for backwards compat with anything still doing
// `import { i18n } from '@/main'`. The instance itself lives in '@/i18n'.
import { i18n } from '@/i18n';
export { i18n };

const app = createApp(App);
const head = createHead();

// Bootstrap directives
app.directive('popover', {
  mounted(el) {
    new Popover(el);
  },
});

app.directive('tooltip', {
  mounted(el) {
    new Tooltip(el);
  },
});

app.directive('offcanvas', {
  mounted(el) {
    Offcanvas.getOrCreateInstance(el);
  },
});

app.directive('scrollspy', {
  mounted(el, binding) {
    const options = binding.value || {};
    new ScrollSpy(el, options);
  },
});

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000,
      },
    },
  },
});
app.use(head);

// Global components
app.component(VueFeather.name!, VueFeather);
app.component('ApexChart', VueApexCharts);
app.component('Swiper', Swiper);
app.component('SwiperSlide', SwiperSlide);

app.mount('#app');
